module.exports = "/pages/business/foodslabo/service_icon_6.png";